module.exports = __webpack_public_path__ + "05_long_gray.fef38849.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/05_long_gray.png
// module id = y4M8
// module chunks = 0